import React from 'react';
import { useSelector } from 'react-redux';
import { ListingCardsCarouselSection } from '../../../containers/ListingPage/Sections';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useCurrentEntityLocation } from '../../../hooks/useCurrentEntityLocation';
import config from '../../../config';
import css from './NearbyListingsSection.css';
import { getOriginString } from '../../../containers/ListingPage/Sections/ListingCardsCarouselSection/ListingCardsCarouselSection.helpers';

const { userTypeHorseowner, userTypeRider, minMatchingRate, listingTypeRider } = config;

const NearbyListingsSection = ({ scoreData, isLoggedOut, user, currentUser, riderListing }) => {
    const { userType: currentUserType, mainHorseId } =
        currentUser?.attributes?.profile?.publicData || {};

    const [, , , viewport] = useIsMobile(1024);

    const horseownerMainListing = useSelector(s => {
        const mainListing = (s.ManageListingsPage?.ownEntities?.ownListing || {})[mainHorseId];
        const mainListingState = mainListing?.attributes?.state;
        const isPublished = mainListingState === 'published';

        if (isPublished) {
            return mainListing;
        }
        return undefined;
    });
    const currentUserIsRider = currentUserType === userTypeRider;
    const currentUserIsOwner = currentUserType === userTypeHorseowner;
    /** Logged in as horseowner */
    const mainListingId = horseownerMainListing?.id;
    const mainListingLocationData = horseownerMainListing?.attributes?.geolocation;
    const mainListingLocationDataAllowed = Boolean(
        currentUserIsOwner && mainListingId && mainListingLocationData
    );
    const mainListingConfig = {
        location: mainListingLocationData,
        allowed: mainListingLocationDataAllowed,
    };
    /** Logged out */
    const publicUserId = user?.id;
    const publicUserLocationData = user?.attributes?.profile?.publicData?.userLocation;
    const publicUserConfig = {
        location: publicUserLocationData,
        allowed: Boolean(publicUserId),
    };

    const entityLocationConfig = mainListingConfig.allowed ? mainListingConfig : publicUserConfig;
    const entityLocationData = useCurrentEntityLocation(entityLocationConfig);
    const entityOriginStr = getOriginString(entityLocationData);
    /**
     * here we treat a main horse as if it is a rider listing
     */
    const pseudoListing = currentUserIsOwner
        ? {
              id: {
                  uuid: mainHorseId,
              },
          }
        : null;
    /**
     * "currentUserIsRider ? false" condition states
     * that other riders have not be matched with current user (rider);
     *
     * "currentUserIsOwner && !mainListingLocationDataAllowed ? false" condition states
     * that horseowners without a main listing have not be matched with riders;
     */
    const isLoggedIn = currentUserIsRider
        ? false
        : currentUserIsOwner && !mainListingLocationDataAllowed
        ? false
        : !isLoggedOut;
    return (
        <section className={css.root}>
            <ListingCardsCarouselSection
                viewport={viewport}
                scoreData={scoreData}
                riderListing={pseudoListing}
                minMatchingRate={minMatchingRate}
                isLoggedIn={isLoggedIn}
                hideButtonsOnEndStart
                matchRiderListing={false}
                currentListing={riderListing}
                params={{ pub_type: listingTypeRider, origin: entityOriginStr }}
            />
        </section>
    );
};

export default NearbyListingsSection;
